import { makeStyles } from '@mui/styles'

const useStyles = makeStyles((theme) => ({
  gradientText: {
    background: 'linear-gradient(124deg, #0BBCED, #1252A5)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: '#0000',
  },
  input: {
    width: '100%',
    color: '#9D9D9D',
    '& input[type=number]': {
      '-moz-appearance': 'textfield',
    },
    '& input[type=number]::-webkit-outer-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0,
    },
    '& input[type=number]::-webkit-inner-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0,
    },
    '& label.Mui-focused': {
      color: '#0068EF',
    },
    '& label.Mui-error': {
      color: 'red',
    },
    '& .MuiInput-underline:after': {
      borderBottomColor: '#0068EF',
    },
    '& .MuiOutlinedInput-root': {
      '&.Mui-focused fieldset': {
        borderColor: '#0068EF',
      },
      '&.Mui-error fieldset': {
        borderColor: 'red',
      },
    },
  },
  payButton: {
    marginTop: '10px !important',
    width: 220,
    height: 48,
    border: 'none',
    outline: 'none',
    boxShadow: '0 4px 14px rgba(0, 104, 239, 0.3) !important',
    color: '#FFFFFF !important',
    fontWeight: 'bold !important',
    borderRadius: '12px !important',
    textTransform: 'none !important',
    fontSize: '16px !important',
    letterSpacing: '0.5px !important',
    transition: 'all 0.3s ease !important',
    '&:hover': {
      transform: 'translateY(-1px)',
      boxShadow: '0 6px 20px rgba(0, 104, 239, 0.4) !important',
    },
  },
  pricingBreakdown: {
    textTransform: 'capitalize',
  },
  pricingBreakdown_final: {
    borderTop: '1px solid #eef1f5',
    backgroundColor: '#F5F9FF',
    padding: '16px 24px !important',
  },
  pricingBreakdown_amount: {
    fontWeight: 'bold',
  },
  cardWidth: {
    width: '100%',
    '@media (min-width:768px)': {
      width: '480px',
    },
  },
}))

export default useStyles
